import { TILE, type TileType } from '../models/Tile';

/**
 * Buildable items for the parking-lot grid (spec section 8).
 *
 * Each item maps to a TileType and carries its economy/effect data. This is the
 * "data" layer: costs/effects live here (content), while global tuning knobs
 * live in economyConfig.ts. Phase 2 items are all 1×1.
 */
export interface BuildingDef {
  id: string;
  name: string;
  tile: TileType;
  purchaseCost: number;
  maintenanceCost: number; // per month (used from Phase 4)
  width: number;
  height: number;
  capacityEffect: number; // parking spaces added
  serviceEffect: number; // 0..1 contribution to service quality (Phase 7)
}

export const BUILDINGS: Record<string, BuildingDef> = {
  road: {
    id: 'road',
    name: 'Road',
    tile: TILE.Road,
    purchaseCost: 2_000,
    maintenanceCost: 100,
    width: 1,
    height: 1,
    capacityEffect: 0,
    serviceEffect: 0,
  },
  parking: {
    id: 'parking',
    name: 'Parking Space',
    tile: TILE.ParkingSpace,
    purchaseCost: 5_000,
    maintenanceCost: 200,
    width: 1,
    height: 1,
    capacityEffect: 1,
    serviceEffect: 0,
  },
  entrance: {
    id: 'entrance',
    name: 'Entrance',
    tile: TILE.Entrance,
    purchaseCost: 25_000,
    maintenanceCost: 500,
    width: 1,
    height: 1,
    capacityEffect: 0,
    serviceEffect: 0.1,
  },
  exit: {
    id: 'exit',
    name: 'Exit',
    tile: TILE.Exit,
    purchaseCost: 25_000,
    maintenanceCost: 500,
    width: 1,
    height: 1,
    capacityEffect: 0,
    serviceEffect: 0.1,
  },
  cashier: {
    id: 'cashier',
    name: 'Cashier',
    tile: TILE.Cashier,
    purchaseCost: 40_000,
    maintenanceCost: 1_000,
    width: 1,
    height: 1,
    capacityEffect: 0,
    serviceEffect: 0.2,
  },
};

/** Order of items shown in the build palette (spec section 28). */
export const BUILD_PALETTE: string[] = [
  'road',
  'parking',
  'entrance',
  'exit',
  'cashier',
];

export function getBuilding(id: string): BuildingDef | undefined {
  return BUILDINGS[id];
}
